import { DEFAULT_AUTHENTICATED_PATH } from '@/auth/session';
import { Button } from '@/components/ui/button';
import { SAMPLE_GAME } from '@/lib/sample';
import { useConnectPath, useSampleMode } from './useSampleMode';

const badge = 'rounded-[4px] px-1.5 py-px text-2xs font-semibold tracking-wide';

/**
 * Above every screen while the tab explores sample data: says whose data this
 * is, and offers the two ways out. "Connect your ad networks" is the point of
 * the whole sample, so it is the emphasised action.
 */
export function SampleBanner() {
  const sample = useSampleMode();
  const connectTo = useConnectPath();
  if (!sample.active) return null;
  return (
    <div role="status" data-tour="sample-banner" className="flex flex-wrap items-center gap-2.5 border-b border-line bg-accent-wash px-gutter py-2 text-sm text-fg">
      <span className={`${badge} bg-accent-ink text-on-blue`}>SAMPLE</span>
      <span>
        You’re exploring sample data from <strong className="font-semibold">{SAMPLE_GAME}</strong>, a fictional game.
      </span>
      <span className="ml-auto flex items-center gap-2">
        <Button size="sm" variant="ghost" onClick={() => { void sample.exit(DEFAULT_AUTHENTICATED_PATH); }}>
          Exit sample
        </Button>
        <Button size="sm" variant="primary" onClick={() => { void sample.exit(connectTo); }}>
          Connect your ad networks
        </Button>
      </span>
    </div>
  );
}

/** The way in, wherever an account has nothing of its own to show yet. */
export function ExploreSampleButton({ className }: { className?: string }) {
  const sample = useSampleMode();
  return (
    <Button className={className} onClick={() => { void sample.enter(); }}>
      Explore with sample data
    </Button>
  );
}
